import companyTickers from "./processed_company_tickers.json";
import Fuse from "fuse.js";
import SymbolOption from "./SymbolOption";

const exactFuse = new Fuse(companyTickers, {
  isCaseSensitive: false,
  threshold: 0.0,
  keys: ["symbol"], // search by symbol and name
});

function exactSymbolMatch(symbol: string | null | undefined): SymbolOption | undefined {
  if (symbol === undefined || symbol === null) {
    return undefined;
  }
  const exactSearch = exactFuse.search(symbol).map((option) => option.item);
  if (exactSearch.length > 0) {
    return exactSearch[0];
  } else {
    return undefined;
  }
}

export default exactSymbolMatch;
